import { Form, Button, Checkbox, Input, Typography, Card, Space, Image, theme } from 'antd';
import React from 'react';
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import ThemeConfig from '../../theme';
import { useAuth } from '../../hooks/useAuth';
import './verify.css';

const { Title, Text } = Typography;

export default function VerifyAuthentication() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { verify, user } = useAuth();
  const otpKey = searchParams.get('otp-key');

  if (user) {
    return <Navigate to="/" />;
  }

  const onFinish = values => {
    console.log('Success:', values);
    verify({ ...values, otpKey });
    //navigate('/');
  };
  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  return (
    <ThemeConfig>
      <section className="section">
        <div className="sidebar">
          <Image src="./images/uab-black-logo.png" preview={false} />
          <Title style={{ color: 'whitesmoke', paddingTop: '9rem' }}>uab Securities</Title>
        </div>

        <div className="verify-header">
          <Image
            src={`${process.env.PUBLIC_URL}/images/uab-security-removebg.png`}
            width={200}
            preview={false}
          />
          {/* <Title style={{ margin: 0 }} level={5}>
            Stock Brokerage System
          </Title> */}
        </div>

        <div className="verify-form-wrapper">
          <Form
            className="verify-form"
            labelCol={{
              span: 24,
            }}
            // wrapperCol={{
            //   span: 16,
            // }}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="OTP Code"
              name="otpCode"
              rules={[
                {
                  required: true,
                  message: 'Please input your opt code!',
                },
              ]}
              style={{ width: '100%' }}
            >
              <Input.OTP length={6} style={{ width: '100%', justifyContent: 'space-between' }} />
            </Form.Item>

            <Button
              className="verify-button"
              type="primary"
              htmlType="submit"
              style={{ borderRadius: 20, float: 'right' }}
            >
              Verify
            </Button>
          </Form>
        </div>
      </section>
    </ThemeConfig>
  );
}
